import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62356116"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "q-pa-lg ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = { style: {"display":"flex","align-items":"left","justify-content":"left"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = { class: "q-pa-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_invoice_model = _resolveComponent("invoice-model")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "warning_amber",
                style: {"font-size":"2rem","position":"relative","top":"-3px"},
                color: "red"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.alerts')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_table, {
        grid: _ctx.$q.platform.is.mobile,
        class: "my-sticky-header-table",
        title: "",
        "rows-per-page-options": [0],
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
        rows: _ctx.alerts,
        cols: _ctx.alerts,
        columns: _ctx.columns,
        "visible-columns": _ctx.visibleColumns,
        "row-key": "name",
        flat: "",
        bordered: ""
      }, {
        body: _withCtx((props) => [
          _createVNode(_component_q_tr, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_q_td, {
                key: "data",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.date), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_td, {
                key: "descriere",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.description), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_td, {
                key: "action",
                props: props
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    color: "black",
                    align: "center",
                    icon: "more_vert",
                    style: {"min-width":"4rem"},
                    onClick: ($event: any) => (_ctx.openAlert(props.rowIndex))
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        item: _withCtx((props) => [
          _createVNode(_component_q_card, {
            class: "my_card",
            style: {"background-color":"white"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, {
                    key: "data",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.date_time')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.row.date), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_item, {
                    key: "descriere",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.description')) + ":", 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_label, {
                            caption: "",
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.row.description), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_item, {
                    key: "action",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.options')) + ":", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    color: "black",
                    align: "center",
                    icon: "more_vert",
                    style: {"min-width":"4rem"},
                    onClick: ($event: any) => (_ctx.openAlert(props.rowIndex))
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["grid", "pagination", "rows", "cols", "columns", "visible-columns"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showAlert,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAlert) = $event)),
        "full-width": _ctx.$q.platform.is.mobile
      }, {
        default: _withCtx(() => [
          _createVNode(_component_invoice_model, { bill_nr: _ctx.bill_nr }, null, 8, ["bill_nr"])
        ]),
        _: 1
      }, 8, ["modelValue", "full-width"])
    ])
  ]))
}